import { render, staticRenderFns } from "./ProductsSortSubCategory.vue?vue&type=template&id=588c1337&scoped=true"
import script from "./ProductsSortSubCategory.vue?vue&type=script&lang=js"
export * from "./ProductsSortSubCategory.vue?vue&type=script&lang=js"
import style0 from "./ProductsSortSubCategory.vue?vue&type=style&index=0&id=588c1337&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588c1337",
  null
  
)

export default component.exports